import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";

const OBJECT_IDS = {
  COBERTURA_BASE_TABLE: "e60e9427-1edd-4c70-865c-7de60bbdcd40",
};

const PerformanceCard = ({ app }) => {
  return (
    <Grid container className="container-cards-kpi">
      <Card app={app} className={"card-kpi-item"} header={{ hardTitle: "Ranking por UF" }}>
        <NativeObject
          app={app}
          key={OBJECT_IDS.COBERTURA_BASE_TABLE}
          style={{ width: "100%", height: "55vh" }}
          reference={{ id: OBJECT_IDS.COBERTURA_BASE_TABLE }}
          className={"table-item-ranking"}
        />
      </Card>
    </Grid>
  );
};

PerformanceCard.propTypes = {
  app: PropTypes.object.isRequired,
};

export default PerformanceCard;
